import { Link, useNavigation, useRouteLoaderData, Form, json, redirect, useNavigate, useSubmit } from "react-router-dom";
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import classes from './EditMedicine.module.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEdit, FaIdCard, FaBuilding, FaBarcode, FaSave, FaTimes } from 'react-icons/fa';
import ConfirmModal from "../../UI/ConfirmModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const EditMedicine = () => {
  const { t } = useTranslation();
  const medicineInfo = useRouteLoaderData('medicine-Info');
  const navigation = useNavigation();
  const navigate = useNavigate();
  const isSubmitting = navigation.state === 'submitting';

  const submit = useSubmit();
  const [showUpdateConfirm, setShowUpdateConfirm] = useState(false);
  const [pendingForm, setPendingForm] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setPendingForm(event.currentTarget);
    setShowUpdateConfirm(true);
  };

  const confirmUpdate = () => {
    if (pendingForm) {
      submit(pendingForm);
    }
    setShowUpdateConfirm(false);
  };

  function cancelHandler() {
    navigate("..");
  }

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <h3 className='textHead' style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>
        <FaEdit className="me-2" /> {t("Edit Medicine Details")}
      </h3>
      <div className={classes.cardview}>
        <Form method="put" className={classes.form} onSubmit={handleSubmit}>

          <div className={classes.sectionHeader}>
            <FaIdCard /> {t("Medicine Basic Info")}
          </div>

          <div className="row">
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="medicineId">{t("Medicine ID")}</label>
              <input id="medicineId" type="text" name="medicineId" required defaultValue={medicineInfo ? medicineInfo?.medicineId : ''} readOnly />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="name">{t("Medicine Name")}</label>
              <input id="name" type="text" name="name" required defaultValue={medicineInfo ? medicineInfo?.name : ''} />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="medType">{t("Medicine Type")}</label>
              <select
                id="medType"
                name="medType"
                defaultValue={medicineInfo ? medicineInfo?.medType : ''}
              >
                <option value="" hidden>{t("Select")}</option>
                <option value="TAB">TAB</option>
                <option value="CAP">CAP</option>
                <option value="SYR">SYR</option>
                <option value="SUSP">SUSP</option>
                <option value="SAC">SAC</option>
                <option value="INJ">INJ</option>
                <option value="DROP">DROP</option>
                <option value="EDRP">EDRP</option>
                <option value="LIQ">LIQ</option>
                <option value="OINT">OINT</option>
                <option value="CRE">CRE</option>
                <option value="GEL">GEL</option>
                <option value="LOT">LOT</option>
                <option value="POWDER">POWDER</option>
                <option value="SPRAY">SPRAY</option>
                <option value="SUPP">SUPP</option>
                <option value="ROTACAP">ROTACAP</option>
              </select>
            </div>
          </div>

          <div className={classes.sectionHeader}>
            <FaBuilding /> {t("Manufacturing & Pricing")}
          </div>
          <div className="row">
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="manufacturer">{t("Manufacturer Name")}</label>
              <input id="manufacturer" type="text" name="manufacturer" defaultValue={medicineInfo ? medicineInfo?.manufacturer : ''} />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="price">{t("Price")}</label>
              <input id="price" type="text" name="price" defaultValue={medicineInfo ? medicineInfo?.price : ''} />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="disease">{t("Disease")}</label>
              <input id="disease" type="text" name="disease" defaultValue={medicineInfo ? medicineInfo?.disease : ''} />
            </div>
          </div>

          <div className={classes.sectionHeader}>
            <FaBarcode /> {t("Inventory Details")}
          </div>
          <div className="row">
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="expiryDate">{t("Expiry Date")}</label>
              <input id="expiryDate" type="date" name="expiryDate" defaultValue={medicineInfo?.expiryDate} />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="barcode">{t("Barcode")}</label>
              <input id="barcode" type="number" name="barcode" defaultValue={medicineInfo ? medicineInfo?.barcode : ''} />
            </div>
          </div>

          <div className={classes.actions}>
            <button
              type="submit"
              disabled={isSubmitting}
            >
              <FaSave className="me-2" /> {isSubmitting ? t("Saving...") : t("Save Changes")}
            </button>
            <button
              type="button"
              onClick={cancelHandler}
              className={classes.secondaryBtn}
            >
              <FaTimes className="me-2" /> {t("Cancel")}
            </button>
          </div>
        </Form>
      </div>
      <ConfirmModal
        show={showUpdateConfirm}
        onHide={() => setShowUpdateConfirm(false)}
        onConfirm={confirmUpdate}
        title={t("Update Medicine")}
        message={t("Are you sure you want to save the changes to this medicine information?")}
        variant="update"
        confirmText={t("Update")}
      />
    </div>
  );
}

export default EditMedicine;

export async function action({ request }) {
  const data = await request.formData();
  const method = request.method;
  const MedicineData = {
    medicineId: data.get('medicineId'),
    name: data.get('name'),
    medType: data.get('medType'),
    manufacturer: data.get('manufacturer'),
    price: data.get('price'),
    disease: data.get('disease'),
    expiryDate: data.get('expiryDate'),
    barcode: data.get('barcode'),
  }
  const token = getAuthToken();
  if (token === null || token === 'EXPIRED') {
    return redirect('/');
  }
  const apiChar = getApiChara();
  const apiUrl = `${apiChar}/medicine/updateMedicine`;

  try {
    const response = await fetch(apiUrl, {
      method: 'PUT',
      body: JSON.stringify(MedicineData),
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + token
      }
    });
    if (!response.ok) {
      toast.error("Could not updated medicine");
      throw json({ message: 'Could not updated medicine.' }, { status: 500 });
    } else {
      const data = await response.json();
      toast.success("Medicine edited successfully!");
      return redirect('..');
    }
  }
  catch (error) {
    toast.error("Could not updated medicine");
    console.error('There has been a problem with your fetch operation:', error);
  }
}